import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingButton from '../fw/LoadingButtonNew.react';
import RunFlowTestsMutation from './RunFlowTestsMutation.react';
import showNotification, { showJobNotification } from '../app/notification';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import { getPayloadErrorMessage } from '../snapshot-testing/mutationPayload.ts';

export class RunTestsButton extends React.Component {
    static propTypes = {
        relay: PropTypes.object,
        flowId: PropTypes.string,
        organisationId: PropTypes.string,
        flowDefId: PropTypes.string,
        executeWrites: PropTypes.bool,
        testCount: PropTypes.number,
        intl: PropTypes.object,
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    handleClick = async () => {
        const { intl, relay, flowId, flowDefId, organisationId, executeWrites } = this.props;

        this.setState({ isLoading: true });
        try {
            const response = await new Promise((resolve, reject) => {
                relay.commitUpdate(
                    new RunFlowTestsMutation({
                        flowId,
                        flowDefId,
                        executeWrites,
                    }),
                    { 
                        onSuccess: resolve,
                        onFailure: reject 
                    }
                );
            });

            const result = response.runFlowTests;
            const payloadError = getPayloadErrorMessage(result, intl.formatMessage({
                id: 'flowTests.error',
                defaultMessage: 'Failed to run tests',
            }));
            if (payloadError) {
                showNotification(payloadError, '');
                return;
            }

            if (result.job) {
                showJobNotification(intl, result.job);
            }

            window.dispatchEvent(new window.CustomEvent('snapshot-tests-run', {
                detail: {
                    flowId,
                    flowDefId,
                }
            }));

            // Navigate to results page
            if (flowId && organisationId) {
                this.context.router.push(urlMapping.getUrl(types['flows'], 'test-results', { organisation_id: organisationId, id: flowId }));
            } else if (flowDefId) {
                this.context.router.push(urlMapping.getUrl(types['flowDefs'], 'test-results', { id: flowDefId }));
            }
        } catch (error) {
            showNotification(intl.formatMessage({
                id: 'flowTests.error',
                defaultMessage: 'Failed to run tests',
            }), '');
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const { isLoading } = this.state;

        return (
            <span>
                <LoadingButton
                    className="btn btn-default"
                    onClick={this.handleClick}
                    isLoading={isLoading}
                    icon="fa-play"
                    progressText={
                        <FormattedMessage
                            id="flow.testing"
                            defaultMessage="Testing"
                        />
                    }
                    text={
                        <FormattedMessage
                            id="flow.runTests"
                            defaultMessage="Run Tests"
                        />
                    }
                />
            </span>
        );
    }
}

export default injectIntl(RunTestsButton);
